"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ProductSize_1 = __importDefault(require("../../../common/ProductSize"));
var product_descriptions_1 = __importDefault(require("../../../../mocks/product-descriptions"));
var markup_1 = require("../../../../utils/markup");
var GenericTabs_1 = __importDefault(require("../../../common/GenericTabs"));
var getTabContent = function (item, seo) {
    var _a, _b;
    var section;
    switch (item.id) {
        case 'material':
            if (item.content.description)
                section = {
                    key: 1,
                    label: 'Описание',
                    children: (react_1.default.createElement(DescriptionText, { dangerouslySetInnerHTML: (0, markup_1.markup)((_a = seo.description) !== null && _a !== void 0 ? _a : item.content.description) }))
                };
        case 'size':
            if (item.content.table)
                section = {
                    key: 3,
                    label: 'Таблица размеров',
                    children: react_1.default.createElement(ProductSize_1.default, { content: { table: item.content.table } })
                };
        case 'printing':
            if (item.content.printingInfo)
                section = {
                    key: 4,
                    label: 'Способ печати и уход',
                    children: (react_1.default.createElement("div", { dangerouslySetInnerHTML: (0, markup_1.markup)((_b = seo.printingInfo) !== null && _b !== void 0 ? _b : item.content.printingInfo) }))
                };
    }
    return section;
};
var ProductInfo = function (props) {
    var tabs = Array({
        key: 2,
        label: 'Цены',
        children: (react_1.default.createElement(DescriptionText, { dangerouslySetInnerHTML: (0, markup_1.markup)(props.priceList) }))
    });
    (product_descriptions_1.default[props.singular] || []).forEach(function (item) {
        var content = getTabContent(item, props.seo);
        content && tabs.push(content);
    });
    return react_1.default.createElement(GenericTabs_1.default, { defaultActiveKey: 2, items: tabs });
};
var DescriptionText = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 25px;\n  color: #3f4547;\n  font-family: Formular;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 24px;\n"], ["\n  margin-top: 25px;\n  color: #3f4547;\n  font-family: Formular;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 24px;\n"])));
exports.default = ProductInfo;
var templateObject_1;
